module.exports = __webpack_public_path__ + "static/img/tx7-b.c563ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/tx7-b.png
// module id = qf+g
// module chunks = 1